const initialState = {
  deviceList: [],
  loading: true,
};

const onlineStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DEVICE_LIST":
      return {
        ...state,
        deviceList: action?.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default onlineStoreReducer;
